import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const countryApi = {
    //查詢国家列表
    "getCountryList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}country/getCountryList`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {}
        }
    },

}

export default countryApi